module.exports = __webpack_public_path__ + "img/0x682F81e57EAa716504090C3ECBa8595fB54561D8.1ee4a1ab.png";